/**
 * Created by mcochrane on 25/08/17.
 */
import { MultiRegExp } from './MultiRegExp'
// import {getAllComponentInstances} from './components'
// import {addScript, addCss} from './helpers'
import { addScript } from './helpers'
// import {ComponentDefinition} from './ComponentDefinition'
import Vue from 'vue'
import store from '../../store'

export class CompInst {
  /**
   *
   * @param match
   * @param matchIndex
   * @param name
   * @param note
   * @param cmpDef
   * @param subMatches
   * @param saveFunc      function  A function used to save the note if changes are made (probably a throttled save func)
   */
  constructor (match, matchIndex, name, note, cmpDef, subMatches, saveFunc) {
    // assert(cmpDef instanceof ComponentDefinition)
    this.md = match
    this.mdIndex = matchIndex
    this.name = name
    this.note = note
    this.componentType = cmpDef.type
    this.component = null
    this.saveFunc = saveFunc || null
    this.subMatches = subMatches
    this.cmpDef = cmpDef
    this.css = '\n' + cmpDef.css + '\n'

    if (cmpDef.js == null) {
      this.js = ''
    } else {
      this.js = `Vue.nextTick(function () { 
  Vue.nextTick(function () {
    try {
      const instance = findComponentWithName('${this.name}');
      instance.component = window.${cmpDef.getJsScriptName()}(instance)
    } catch (ex) {
      console.warn('error in component ${this.name}: ' + ex);
      $ch.log(ex)
    }
  })
})`
    }

    this.scriptNode = null
    this.htmlNode = null
    this.html = cmpDef.html.replaceAll('\\$NAME', name)
  }

  /**
   * Returns the value of the specified submatch.
   * example:
   * regex is /(a)(b)(c)/g and we pass the string "abc".
   * Then getSubmatch(1) is "a", getSubmatch(2) is "b" and so on.
   * @param index     one-based index
   * @public
   * @name getSubmatch
   * @ternType fn(index: number)
   * @ternDoc Returns the value of the n'th submatch from the markdown.  The first submatch has index of 1.
   */
  getSubmatch (index) {
    // var t = this.md // eslint-disable-line no-unused-vars
    return this.subMatches[index - 1]
  }

  getSubmatchLocations () {
    let mre = new MultiRegExp(new RegExp(this.cmpDef.md))
    return mre.exec(this.md)
  }

  /**
   * Changes the text of the submatch
   * @param index     one-based index of the submatch to modify
   * @param val       new value to place in the submatch markdown
   * @param redraw    if true, the html will be redrawn (default is false)
   * @public
   * @name setSubmatch
   * @ternType fn(index: number, val: string, redraw: boolean)
   * @ternDoc Sets the n'th submatch from the markdown to the value specified.
   */
  setSubmatch (index, val, redraw = false) {
    index = index - 1
    let subMatches = this.getSubmatchLocations()

    if (index >= subMatches.length) throw new Error('submatch index ' + index + ' did not exist')

    let match = subMatches[index]
    let newMd = this.md.substr(0, match.index) + val + this.md.substr(match.index + match.text.length)

    this.setMd(newMd)

    Vue.set(this.subMatches, index, val)

    if (!redraw) {
      store.commit('setSkipMdRender', true)
    }
  }

  isInDOM () {
    return this.htmlNode !== null
  }

  /**
   * Returns the type of component (eg. Checkbox, NoteLink, etc).
   * @public
   * @name getComponentType
   * @ternType fn() -> string
   * @ternDoc Returns the type of component (eg. Checkbox, NoteLink, etc).
   */
  getComponentType () {
    return this.componentType
  }

  /**
   * Returns the compiled HTML of this component.
   * @public
   * @name getHtml
   * @ternType fn() -> string
   * @ternDoc Returns the compiled HTML of this component.
   */
  getHtml () {
    return this.html
  }

  /**
   * Use to bind vue component to this element (eg. `el: $tc.vueRootElSelector`)
   * @public
   * @name vueRootElSelector
   * @ternType fn() -> string
   * @ternDoc Use to bind vue component to this element (eg. `el: $tc.vueRootElSelector`)
   */
  vueRootElSelector () {
    return '#' + this.getPlaceholderName()
  }

  getPlaceholderName () {
    return '__' + this.name + '__'
  }

  genHtmlPlaceholder () {
    return '<span id=\'' + this.getPlaceholderName() + '\'></span>'
  }

  findPlaceholderInDocument () {
    return document.getElementById(this.getPlaceholderName())
  }

  /**
   * Returns the javascript of this component instance.
   * @public
   * @name getJs
   * @ternType fn() -> string
   * @ternDoc Returns the javascript for this component instance.
   */
  getJs () {
    return this.js
  }

  writeJsToDOM () {
    try {
      this.scriptNode = addScript(this.js)
    } catch (ex) {
      // if (ex.msg.startsWith('Uncaught SyntaxError')) {
      //   console.log('nopeaa...')
      // }
      // console.log(ex)
    }
  }

  deleteJsFromDOM () {
    if (this.scriptNode != null) {
      document.body.removeChild(this.scriptNode)
      this.scriptNode = null
    }
  }

  writeHtmlToDOM () {
    Vue.nextTick(() => {
      console.log('Wrote component ' + this.name + ' HTML to DOM')
      this.htmlNode = this.findPlaceholderInDocument()
      this.htmlNode.innerHTML = this.html
      console.log(this.htmlNode)
    })
  }

  /**
   * Replaces the 'new' placeholder with the old one.
   */
  updateHtmlInDOM () {
    var t = this
    this.htmlNode = this.findPlaceholderInDocument()
    Vue.nextTick(() => {
      let placeholder = t.findPlaceholderInDocument()
      placeholder.parentNode.replaceChild(t.htmlNode, placeholder)
    })
  }

  /**
   * Returns the markdown of this component.
   * @public
   * @name getMd
   * @ternType fn() -> string
   * @ternDoc Returns the markdown for this component instance.
   */
  getMd () {
    return this.md
  }

  /**
   * Change the location that the component's markdown starts in the full markdown.
   * For example, suppose the full markdown is "012[ ]678" and "[ ]" is the markdown that
   * corresponds to this component.  The mdIndex would be 3.  If we changed the full markdow to
   * "012[ ]678" then the component is now at mdIndex 2, the component could be updated and a
   * new index set through this function rather than destroying the component and rebuilding it.
   * @param newIndex
   */
  setMdIndex (newIndex) {
    this.mdIndex = newIndex
  }

  /**
   * Internal function
   * Checks if the passed string still matches the regex pattern for the component
   * @param newMd     the new markdown string to test
   * @return *        false if no match or the match if there was a match
   */
  checkMd (newMd) {
    let match = newMd.match(new RegExp(this.cmpDef.md))
    if (match === null) {
      return false
    } else {
      return match
    }
  }

  setMd (newMarkdown) {
    if (this.checkMd(newMarkdown) === false) throw new Error('new markdown does not match regex! Not changed.')
    if (this.note != null) {
      Vue.set(this.note, 'data', this.note.data.substr(0, this.mdIndex) + newMarkdown +
        this.note.data.substr(this.mdIndex + this.md.length))
      if (this.saveFunc) this.saveFunc()
      var lenChange = newMarkdown.length - this.md.length
      var checkAfterIndex = this.mdIndex + this.md.length
      window._cmpInsts.forEach((cmp) => {
        if (cmp.mdIndex >= checkAfterIndex) {
          cmp.setMdIndex(cmp.mdIndex + lenChange)
        }
      })
      // console.log("setMd: (" + this.name + ") - " + this.note.data)
    }
    this.md = newMarkdown
    // TODO: If the length of the markdown for this component changes we need to update all other components after this one.  Just have to update their mdIndex value!
  }

  equalsMatch (match, index, componentType) {
    // return (this.getMd() === string) && index === this.mdIndex
    return (this.getComponentType() === componentType) && index === this.mdIndex && match === this.md
  }
}
